/* eslint-disable */
/* ***********************************************************
* A short word on how to use this automagically generated file.
* We're often asked in the ignite gitter channel how to connect
* to a to a third party api, so we thought we'd demonstrate - but
* you should know you can use sagas for other flow control too.
*
* Other points:
*  - You'll need to add this saga to sagas/index.js
*  - This template uses the api declared in sagas/index.js, so
*    you'll need to define a constant in that file.
*************************************************************/

import { call, put, select } from 'redux-saga/effects'
import ReloginActions from '../Redux/ReloginRedux'
import UserActions from '../Redux/UserRedux'
// import { ReloginSelectors } from '../Redux/ReloginRedux'
import { NavigationActions } from 'react-navigation'
//import OneSignal from 'react-native-onesignal'
import { OfflineMessaging } from '../Services/OfflineMessaging'

//import * as Keychain from 'react-native-keychain' // for sharing token w/ app extensions

import { KargoeConfig } from '../Config/AppConfig'
const baseURL = KargoeConfig.baseUrlAPI

export const selectAuthToken = (state) => state.auth.token
export const authDebug = (state) => state.auth
export const notificationId = (state) => state.auth.user.NotificationId

const storeTokenToKeychain = (Username, UserId, token) => {

  const username = Username + '|' + UserId + '|' + baseURL
  const password = token

  // Store the credentials so the app extension (share to kargoe separate executable) can access them
  if (false)
  Keychain.setGenericPassword(username, password).then((x) => {
      try {
        // Retrieve the credentials (test that the set worked)
        const credentials =  Keychain.getGenericPassword().then((credentials) => {
          if (credentials) {
            console.log(
              'Credentials successfully loaded ' + JSON.stringify(credentials)
            )
          } else {
            console.log('No credentials found in keychain')
          }
        })
      } catch (error) {
        console.log("Keychain couldn't be accessed!", error);
      }
  }).catch((x) => {
    console.log("catch error storing token to keychain, x = " + JSON.stringify(x))
  })

}

export const getRelogin = function* getRelogin(api) {

  try {
    const token = yield select(selectAuthToken)
    const auth = yield select(authDebug)
    const notifId = yield select(notificationId)
    const userCurrency = typeof auth.user.Currency == 'undefined' || auth.user.Currency == null ? null : auth.user.Currency
    console.log("getRelogin token = " + token) // this gets called at app launch if logged in already
    storeTokenToKeychain(auth.user.Username, auth.user.UserId, token)
    console.log("notifId  = " + notifId)
    console.tron.log(`getRelogin token: ${token}, notifId: ${notifId}, userCurrency: ${userCurrency}`)
    if (token) {
      OfflineMessaging.init(auth.user.UserId)
      yield call(api.setAuthorization, token)
      if (userCurrency == null)
        yield put(UserActions.setUserDefaultCurrency())
      const resetAction = NavigationActions.reset({
        index: 0,
        actions: [
          NavigationActions.navigate({ routeName: 'home', params : {isScroll : true, from: 'ReloginSagas'} })
        ],
      });
      //OneSignal.sendTag('kargoe_username', notifId)
      yield put(resetAction)
      yield put({ type : 'WEBSOCKET_INIT' })
      yield put(ReloginActions.reloginSuccess())
    } else {
      const resetAction = NavigationActions.reset({
        index: 0,
        actions: [
          NavigationActions.navigate({ routeName: 'auth' })
        ],
      });

      yield put(resetAction)
    }


  } catch (e) {
    console.log("getRelogin saga error : " + JSON.stringify(e))
    /*
    console.tron.display({
      name: 'getRelogin saga errorr',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
    */
    const resetAction = NavigationActions.reset({
      index: 0,
      actions: [
        NavigationActions.navigate({ routeName: 'auth' })
      ],
    });

    yield put(resetAction)
  }
}
